import React, { useEffect, useState } from 'react';
import { ENavType } from 'constants/nav';
import NavStep from 'components/NavStep/NavStep';
import { Form } from 'antd';
import ButtonFooter from 'components/ButtonFooter/ButtonFooter';
import { TAnswerTrainingResults, TTrainingResult } from 'types/trainingResult';
import { TQuestions } from 'types/questions';
import { useHistory, useParams } from 'react-router-dom';
import commonRender from 'hook/commonRender';
import { convertData, converDataAfterSave } from 'libs/helpers/convertData';
import EditTraining from 'libs/hook/EditTraining';
import { IndexedObject } from 'constants/types';
import { routers } from 'constants/router';
import ModalConfirm from 'components/ModalConfirm/ModalConfirm';
import HeaderTraining from 'components/HeaderTraining';
import AssignmentCalculationYieldsForm from './AssignmentCalculationYieldsForm';
import styles from './style.module.scss';
import { configTable1 } from './AssignmentCalculationSettingsYields.state';

const AssignmentsQuestion: React.FC<{
  trainingResult: TTrainingResult;
  updateTrainingResult: (data: TAnswerTrainingResults, id: string) => void;
  resetTrainingResult: () => void;
}> = ({ trainingResult, updateTrainingResult, resetTrainingResult }) => {
  const [nextStep, setNextStep] = useState(false);
  const [urlLink, setUrlLink] = useState<string | undefined>();
  const [configTable, setConfigTable] = useState<any>();
  const [trainingResultState, setTrainingResultState] = useState<TTrainingResult | null>();
  const [data, setData] = useState<TQuestions[]>([]);
  const [failedData, setFailedData] = useState<IndexedObject>({});
  const [showModal, setShowModal] = useState(false);
  const { trainingId } = useParams<{ trainingId: string }>();
  const [renderValue] = commonRender();
  const currentStep = 4;

  const [form] = Form.useForm();
  const history = useHistory();

  EditTraining();

  useEffect(() => {
    if (trainingResultState?.updated) {
      if (urlLink) {
        history.push(urlLink);
      } else if (nextStep) {
        history.push(routers.U7_5.path.replace(':trainingId', trainingId));
      } else {
        history.push(routers.U7_3.path.replace(':trainingId', trainingId));
      }
      resetTrainingResult();
    }
  }, [trainingResultState]);

  useEffect(() => {
    if (trainingResult.training?.template) {
      setTrainingResultState(trainingResult);
      setConfigTable(configTable1(trainingResult.training?.template ?? {}, trainingResult));
    }
  }, [trainingResult]);

  useEffect(() => {
    if (trainingResult?.training?.template?.step2) {
      const step = trainingResult?.training?.template?.step2.filter((assignment) => assignment.step === currentStep);
      setData(step);
      if (trainingResult?.step4?.answer) {
        form.setFieldsValue(convertData(trainingResult?.step4?.answer));
      }
    }
  }, [trainingId, trainingResult]);

  const onFinish = (values: IndexedObject) => {
    const answer = converDataAfterSave(data, values);
    updateTrainingResult({ isCompleted: true, answer }, trainingId);
  };

  const onFinishFailed = (errorInfo: IndexedObject) => {
    setShowModal(true);
    setFailedData(errorInfo.values);
  };

  const onClickPreStep = () => {
    form.submit();
  };

  const onClickNextStep = () => {
    setNextStep(true);
    form.submit();
  };

  const handelConfirm = () => {
    const answer = converDataAfterSave(data, failedData);
    updateTrainingResult({ isCompleted: false, answer }, trainingId);
  };

  const onChangeValue = (changed: IndexedObject, values: IndexedObject) => {
    const answer = converDataAfterSave(data, values);
    if (trainingResultState && trainingResultState.step4) {
      const newData = { ...trainingResultState, step4: { ...trainingResultState.step4, answer } };
      setTrainingResultState(newData);
      setConfigTable(configTable1(trainingResultState.training?.template, newData));
    }
  };

  const clickChangeRoute = (link: string) => {
    form.submit();
    setUrlLink(link);
  };

  return (
    <>
      <div className={styles.assignmentsQuestionWrap}>
        <HeaderTraining />
        <NavStep type={ENavType.student} onClick={clickChangeRoute} />
        <div className={styles.content}>
          <div className={styles.contentWrap}>
            <div className={styles.contentWrap__left}>
              <div className={styles.contentTitle}>設問</div>
              <div className={styles.form}>
                <Form
                  form={form}
                  onValuesChange={onChangeValue}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                  layout="vertical"
                >
                  {data.map((questions) => questions.questions.map((question) => renderValue(question)))}
                </Form>
              </div>
            </div>
            <div className={styles.contentWrap__right}>
              <div className={styles.contentTitle}>参考情報</div>
              <div className={styles.form}>
                {configTable && <AssignmentCalculationYieldsForm configTable={configTable} />}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ButtonFooter handelClickNext={onClickNextStep} handelClickPre={onClickPreStep} />
      <ModalConfirm
        open={showModal}
        onClose={() => setShowModal(false)}
        handleConfirm={handelConfirm}
        title="確認"
        subTitle="設問回答がすべて終了していません。ここまでの設問回答を保存して他のページに移動しますか？"
      />
    </>
  );
};

export default AssignmentsQuestion;
